import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
function Navbar({ homeSectionRef, serviceRef, priceRef,ongoingRef,completedRef }) {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentSection, setCurrentSection] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false); 
  const [showDropdown, setShowDropdown] = useState(false); 

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  const scrollToSection = (sectionRef, sectionName) => {
    if (currentSection !== sectionName && sectionRef.current) {
      const offsetTop = sectionRef.current.offsetTop;
      window.scrollTo({
        top: offsetTop - 50, // Adjust offset if needed
        behavior: 'smooth',
      });
      setCurrentSection(sectionName);
    }
  };

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}style={{ position: 'absolute', top: '50%', left: '5px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
          <img src='images/Ba-1.png' alt="Build Angles Logo" style={{ height: '50px',width:'50px',marginRight: '10px' }} />
              Build <span>Angles</span>
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link
                to='/'
                className='nav-links'
                onClick={(e) => {
                  e.preventDefault();
                  closeMobileMenu();
                  setDropdownOpen(false);
                  
                  setShowDropdown(false);
                  scrollToSection(homeSectionRef, 'home');
                }}
              >
                Home
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/'
                className='nav-links'
                onClick={(e) => {
                  e.preventDefault();
                  closeMobileMenu();
                  setDropdownOpen(false);
                  setShowDropdown(false);
                  scrollToSection(serviceRef, 'service');
                }}
              >
                Services
              </Link>
            </li>
           
           
            <li className='nav-item dropp' onClick={() => setDropdownOpen(!dropdownOpen)} >
              <Link
                to='#'
                className='nav-links'
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown();
                }}
              >
                Projects
              </Link>
              {dropdownOpen && (
                <ul className='dropdown-menu'>
                  <li>
                    <Link
                      to='#'
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(ongoingRef, 'ongoing');
                      }}
                    >
                      Ongoing
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='#'
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(completedRef, 'completed');
                      }}
                    >
                      Completed
                    </Link>
                  </li>
                  </ul>
                )}
                </li>
          
            <li className='nav-item'>
            <Link
                to='/'
                className='nav-links'
                onClick={(e) => {
                  e.preventDefault();
                  closeMobileMenu();
                  setDropdownOpen(false);
                  setShowDropdown(false);
                  scrollToSection(priceRef, 'price');
                }}
              >
                Price
              </Link>
              </li>
              <li>
                <Link
                  to='/popup'
                  className='nav-links-mobile'
                  onClick={() => { closeMobileMenu(); setDropdownOpen(false); setShowDropdown(false); setShowModal(true); }} // Open modal when link is clicked
                >
                  Send Message
                </Link>
              </li>
          </ul>
          {button && (
            <Button buttonStyle='btn--outline' onClick={() => setShowModal(true)}>Send Message</Button> // Open modal when button is clicked
          )}
          
          
          
        </div>
      </nav>
    </>
  );
}

export default Navbar;
 